module.exports = __webpack_public_path__ + "static/hackathonNews-3b5f05dfd6549c882456b6577efc0533.png";